import { createFileRoute, redirect } from '@tanstack/react-router'
import { ExpenseClaimDetail } from '@/features/hr-expenses/expense-claim-detail'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one expense claim and its receipts.
 *
 * The grant guard is `expense.view`, the same key as the list. Whether the
 * caller may see THIS claim is the API's answer, not the browser's: an
 * own-scoped employee gets a 403 on a colleague's claim, and the screen
 * surfaces that rather than deciding it here.
 *
 * Per the route-shell rule in `apps/company/AGENTS.md`, this file is a route
 * definition, a guard and a render.
 */
export const Route = createFileRoute('/_authenticated/hr/expenses/$claimId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'expense.view')) {
      // A notification link reaches here without the grant: own requests live on the phone.
      throw redirect({ to: '/get-the-app' })
    }
  },
  component: HrExpenseClaimRoute,
})

function HrExpenseClaimRoute() {
  const { claimId } = Route.useParams()

  return <ExpenseClaimDetail claimId={claimId} />
}
